import { Button } from "@mui/material"
import { useState, useEffect, useLayoutEffect } from "react"

import './CategorieButtons.css'

export const CategoryButton = ({ variant, isDragging, page, item, ix, nbItems, origin, forwardRef, clickHandler }) => {
	forwardRef.current = { arrowTop: 62 / 2, /*tileWidth: style.style.width,*/ edgeShader: true }
	const [firstTileMarginLeft, setFirstTileMarginLeft] = useState(0)
	const [isSelected, setIsSelected] = useState(false)
	const rootCategoryButton = isSelected ? 'categoryButtons categoryButtonSelected' : 'categoryButtons'

	useLayoutEffect(() => {
		setIsSelected(item.id === page.discoverCategory?.selected?.id)
	}, [page.discoverCategory?.selected?.id])

	useEffect(() => {
		if (page.sectionTitleMarginLeft[origin] !== firstTileMarginLeft) setFirstTileMarginLeft(page.sectionTitleMarginLeft[origin])
	}, [page.sectionTitleMarginLeft[origin]])

	return (
		<div /*className="personTile"*/ style={{
			marginLeft: ix === 0 ? firstTileMarginLeft + "px" : 0,
			// doesn't work only on Safari! Use paddingRight instead
			//marginRight: ix === nbItems - 1 ? firstTileMarginLeft + "px" : 0,
			paddingRight: ix === nbItems - 1 ? firstTileMarginLeft + "px" : 0
		}}>
			<Button variant="outlined" style={{ color: "#FFF" }}
				disableRipple={true}
				onClick={(e) => {
					e.preventDefault()
					e.stopPropagation()
					clickHandler(item)
				}}
				classes={{ root: `${rootCategoryButton}` }}
			>{item.displayText}
			</Button>
		</div>
	)
}
